/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./minelucky.vue?vue&type=template&id=47726cfa&scoped=true"
import script from "./minelucky.vue?vue&type=script&lang=js"
export * from "./minelucky.vue?vue&type=script&lang=js"
import style0 from "./minelucky.vue?vue&type=style&index=0&id=47726cfa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47726cfa",
  null
  
)

export default component.exports